(function() {
  var Base,
    slice = [].slice,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Base = App.loadClass('core::Services/MapLayers/Base');

  exports.register = function(module) {
    return module.factory('Core.Services.MapLayers.Field', [
      '$http', 'Core.Services.Map', '$q', function() {
        var args;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        return {
          "new": function() {
            return (function(func, args, ctor) {
              ctor.prototype = func.prototype;
              var child = new ctor, result = func.apply(child, args);
              return Object(result) === result ? result : child;
            })(exports.FieldBoundary, args, function(){});
          }
        };
      }
    ]);
  };

  exports.FieldBoundary = (function(superClass) {
    extend(FieldBoundary, superClass);

    function FieldBoundary() {
      this.getGeoJSON = bind(this.getGeoJSON, this);
      return FieldBoundary.__super__.constructor.apply(this, arguments);
    }

    FieldBoundary.prototype.url = 'backend/grower/fields/get-boundary';

    FieldBoundary.prototype.getGeoJSON = function(response) {
      if (response.data.status.type === 'success') {
        return response.data.data.boundary;
      }
    };

    return FieldBoundary;

  })(Base);

}).call(this);
